module.exports = __webpack_public_path__ + "assets/img/one.5cde06c7.png";